import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

export const VisionService = {
  async analyzeImage(imageUrl: string): Promise<string> {
    try {
      const response = await openai.chat.completions.create({
        model: "gpt-4-vision-preview",
        messages: [
          {
            role: "user",
            content: [
              { type: "text", text: "O que você vê nesta imagem?" },
              { type: "image_url", image_url: imageUrl }
            ],
          },
        ],
        max_tokens: 300,
      });

      return response.choices[0]?.message?.content || "Não foi possível analisar a imagem";
    } catch (error) {
      console.error('Erro ao analisar imagem:', error);
      throw error;
    }
  },

  async generateImage(prompt: string): Promise<string> {
    try {
      const response = await openai.images.generate({
        model: "dall-e-3",
        prompt,
        n: 1,
        size: "1024x1024",
        quality: "standard",
      });

      return response.data[0]?.url || "";
    } catch (error) {
      console.error('Erro ao gerar imagem:', error);
      throw error;
    }
  }
};
